import { AnimatePresence, motion } from 'framer-motion'
import { ExternalLink } from 'lucide-react'
import { Boundary } from '~/components'
import { AddKnowledgeSourceContentProps } from '~/features/knowledge-bases/types'
import { AddKnowledgeSourceHeader } from './AddKnowledgeSourceHeader'
import { useAddKnowledgeSourceStepContext } from './AddKnowledgeSourceStepContext'

export const AddKnowledgeSourceContent = ({ close: _close, hideBackArrow }: AddKnowledgeSourceContentProps) => {
  const { step, changeStep, handleNavigateBack, renderStep, title } = useAddKnowledgeSourceStepContext()

  const close = () => {
    _close()
    changeStep('select_content')
  }

  return (
    <>
      <AddKnowledgeSourceHeader
        hideBackArrow={hideBackArrow || step === 'select_content'}
        handleNavigateBack={handleNavigateBack}
        title={title}
        close={close}
      />

      <div className="w-full overflow-y-auto text-foreground">
        <AnimatePresence mode="popLayout" initial={false}>
          <motion.div
            key={step}
            initial={{ opacity: 0, scale: 0.96, filter: 'blur(3px)' }}
            animate={{ opacity: 1, scale: 1, y: 0, filter: 'blur(0px)' }}
            exit={{ opacity: 0, scale: 0.96, filter: 'blur(3px)' }}
            transition={{ duration: 0.15, ease: 'easeOut' }}
          >
            <Boundary>{renderStep()}</Boundary>
          </motion.div>
        </AnimatePresence>
      </div>
      {step === 'select_content' && (
        <div className="-mx-6 border-t p-6 text-foreground">
          <a
            className="flex items-center justify-center gap-2 text-xs text-muted-foreground hover:text-primary hover:underline lg:justify-start lg:text-sm"
            href="https://botpress.com/docs/learn/reference/knowledge-base/add-sources"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ExternalLink size={16} />
            <p>Learn more about knowledge sources</p>
          </a>
        </div>
      )}
    </>
  )
}
